import React, {createContext} from 'react';

import axios from 'axios';
import { customWarn } from '../CustomLogger';


export const ManualLoginContext = createContext();

class ManualLoginContextProvider extends React.Component {

    constructor(props) {
        super(props);
        const obj = {
            isLoading: false,
            showPasswordField:false,
            showPasswordRequested:false,
            showFailedLogin:false,
            successLogin:false,
            showPasswordHasReset:false,
            accessData:{}
        };
        if ('hash' in props) {
            obj.isLoading=true;
            obj.checkHash = props.hash;
        }
        this.state = obj;
    }

    componentDidMount() {
        if(this.state.checkHash){
            this.checkHash();
        }
    }

    setNewPassword(formData){

        this.setState({
            isLoading:true,
        });

        const apiPath = `${process.env.REACT_APP_API_URL}/connect/setnewpassword`;

        const postData = formData;
        postData.hash = this.state.checkHash;

        axios.post(apiPath,postData,{
            timeout: 30000,
        }).then((res) => {
            const obj= {
                isLoading:false,
            };
            if(res.data.success) {
                obj.showPasswordHasReset=true;
            }
            else{
                obj.showFailedReset=true;
            }
            this.setState(obj)
        }).catch(err => {

            customWarn(err);
        });
    }

    checkHash(){
        const apiPath = `${process.env.REACT_APP_API_URL}/connect/checkhashvalid`;

        axios.post(apiPath,{
            hash:this.state.checkHash
        },{
            timeout: 30000,
        }).then((res) => {
            const obj= {
                isLoading:false,
            };
            if(!res.data.success){
                obj.badToken=true;
            }
            this.setState(obj)
        }).catch(err => {

            customWarn(err);
        });
    }



    requestPassword(email){

        this.setState({
            isLoading:true,
            showFailedLogin:false

        });

        const apiPath = `${process.env.REACT_APP_API_URL}/connect/newpassword`;

        axios.post(apiPath,{
            goEmail:email
        },{
            timeout: 30000,
        }).then(() => {
            this.setState({
                isLoading:false,
                showPasswordRequested:true
            })
        }).catch(err => {

            customWarn(err);
        });
    }

    doLogin(formData,callBack){

        this.setState({
            isLoading:true,
            showFailedLogin:false
        });

        const apiPath = `${process.env.REACT_APP_API_URL}/connect/login`;

        axios.post(apiPath,formData,{
            timeout: 30000,
        }).then(res => {
            const obj = {
                isLoading: false,
                accessData: res.data
            };
            if(res.data.token){
                obj.successLogin = true;
                callBack(res.data);
            }
            else{
                obj.showFailedLogin = true;
            }
            this.setState(obj);
        }).catch(err => {
            this.setState({
                isLoading: false,
                showFailedLogin:true
            });
            customWarn(err);
        });



    }

    render() {
        return (
            <ManualLoginContext.Provider value={{
                ...this.state,
                requestPassword:this.requestPassword.bind(this),
                doLogin:this.doLogin.bind(this),
                setNewPassword:this.setNewPassword.bind(this),
                setState:this.setState.bind(this)
            }}>
                {this.props.children}
            </ManualLoginContext.Provider>
        );
    }
}

export default ManualLoginContextProvider;